import React from 'react';

export default () => (
  <div className="LoadingDot">
    <div className="bounce1"></div>
    <div className="bounce2"></div>
    <div className="bounce3"></div>
  </div>
)
